import React from 'react'
// libs
import { useMutation } from '@apollo/client/react'
// components
import { TableRow } from '@mui/material'
import { HoverablePopover, Table } from 'components/UI'
// constants
import { Modals } from 'constants/index'
// types
import { ISystemProcess } from 'types/graphql'
// views
import { CheckedIcon, TableCell, TEXT_STYLE } from 'themes/views/tables'
// contexts
import { TableManagementContext } from 'containers/Search/layers/BL'
import { SystemProcessesPageContext } from 'containers/SystemProcesses/Table/layers/API'
//graphql
import { RUN_AUTOMATIONS_MUTATION } from 'graphql/systemProcesses/mutations'
// hooks
import { useShowModal } from 'hooks/index'
// themes
import { EllipsizedText } from 'themes/views/generic'
// views
import { Button, ContentContainer, TableDescription } from './views'
// utils
import moment from 'moment'
import capitalize from 'lodash/capitalize'

const HEADERS = [
  { id: 'name', sortable: false, left: true, label: 'NAME' },
  { id: 'object', sortable: false, left: true, label: 'OBJECT' },
  { id: 'type', sortable: false, left: true, label: 'TYPE' },
  { id: 'active', sortable: false, left: true, label: 'ACTIVE' },
  { id: 'created_at', sortable: false, left: true, label: 'DATE CREATED' }
]

const SystemProcessesTable: React.FC = () => {
  const [runAutomationsMutation] = useMutation(RUN_AUTOMATIONS_MUTATION)

  const { handleSetPage, handleSetPerPage, page, perPage } = React.useContext(TableManagementContext)
  const { data, totalCount, refetch, isRefetching } = React.useContext(SystemProcessesPageContext)

  const { showModal } = useShowModal({ modalType: Modals.SYSTEM_PROCESS_CREATE_MODAL })

  const showSystemProcess = (systemProcess: ISystemProcess) => showModal({ systemProcess, isEdit: true })

  const onRunAutomations = async () => {
    await runAutomationsMutation()
  }

  return (
    <ContentContainer>
      <Button data-testid='run-automations' onClick={onRunAutomations}>
        Run Automations
      </Button>
      <TableDescription>
        Processes are triggers and automations which drive notifications and system events
      </TableDescription>

      <Table
        data={data}
        page={page}
        headers={HEADERS}
        perPage={perPage}
        refetch={refetch}
        totalCount={totalCount}
        isLoading={isRefetching}
        onPageChange={handleSetPage}
        onPerPageChange={handleSetPerPage}>
        {({ data }) =>
          data.map((systemProcess) => {
            const { active, createdAt, id, name, object, processType } = systemProcess

            return (
              <TableRow key={id} hover>
                <TableCell size={45} withEllipsis>
                  <HoverablePopover
                    trigger={
                      <EllipsizedText
                        data-testid='system-process'
                        data-entity-id={id}
                        onClick={() => showSystemProcess(systemProcess)}
                        style={TEXT_STYLE}>
                        {name}
                      </EllipsizedText>
                    }>
                    {name}
                  </HoverablePopover>
                </TableCell>
                <TableCell size={20}>{object.replace('RISK_', 'FORM ')}</TableCell>
                <TableCell size={20}>{capitalize(processType)}</TableCell>
                <TableCell size={5}> {active && <CheckedIcon />}</TableCell>
                <TableCell size={10}>{moment(createdAt).format('DD/MM/Y')}</TableCell>
              </TableRow>
            )
          })
        }
      </Table>
    </ContentContainer>
  )
}

export default SystemProcessesTable
